import { FilterChips } from "./FilterChips";
import { useRoles } from "@/hooks/useRoles";

interface RoleFilterProps {
  /** Role ids (uuids). */
  roles: string[];
  selected: string[];
  onToggle: (role: string) => void;
  onClear: () => void;
}

/**
 * Role filter component using FilterChips. Options are role ids; labels are
 * resolved to display names via useRoles().
 */
export function RoleFilter({
  roles,
  selected,
  onToggle,
  onClear,
}: RoleFilterProps) {
  const { formatRole } = useRoles();
  return (
    <FilterChips
      label="Role"
      options={roles}
      selected={selected}
      onToggle={onToggle}
      onClear={onClear}
      allLabel="All Roles"
      formatValue={(value: string) => formatRole(value)}
    />
  );
}
